import {Component, Input, OnInit} from '@angular/core';
import { I18NextService } from 'angular-i18next';
import {Subscription, TariffPlanDetail} from '../../../subscription/subscription.model';
import {tariffNameTranslationKey} from '@myshared/utils';
import {LocalizedDatePipe} from '@myshared/localized-date.pipe';
import {TariffService} from '../../tariff.service';
import {Router} from '@angular/router';
import { Model } from 'src/app/app.model';

@Component({
    selector: 'app-tariff-card',
    templateUrl: './tariff-card.component.html',
    providers: [LocalizedDatePipe],
    standalone: false
})
export class TariffCardComponent implements OnInit {

    @Input() subscription: Subscription;
    @Input() isAdmin: boolean;

    constructor(
      private router: Router,
      private m: Model,
        private tariffService: TariffService,
        private i18next: I18NextService,
        private date: LocalizedDatePipe) {
    }

    ngOnInit() {
    }

    public changeTariff() {
        if (this.isTariffOrdered) return;
        this.router.navigate(['/do', ...this.roleSegment, 'change-tariff', this.subscription.appliance_id, 'choose-tariff-variant']);
    }

    public cancelTariffOrder() {
        this.router.navigate(['/do', ...this.roleSegment, 'change-tariff', this.subscription.appliance_id, 'order-cancel']);
    }

    private get roleSegment() {
        if (!this.subscription.is_my) {
            const user = this.m.account.currentUser;
            if (user.companyIsPC20Csp) return ['csp'];
            else if (user.companyIsPartner) return ['partner'];
        }

        return [];
    }

    get hasTariffDetail(): boolean {
      return !!this.subscription?.tariffPlanDetail?.currentPlan
        && this.subscription?.tariffPlanDetail?.currentPlan !== 'PC-ONE-TARIFF-TRIAL';
    }

    get tariffDetail(): TariffPlanDetail {
      return this.subscription?.tariffPlanDetail;
    }

    get currentTariffName() {
      return this.getTariffName(this.tariffDetail.currentPlan);
    }

    get orderedTariffName() {
      return this.getTariffName(this.tariffDetail.orderedPlan);
    }

    get orderedTariffDate() {
      return this.date.transform(this.tariffDetail.orderedPlanActivationDate);
    }

    get isTariffOrdered() {
      return this.subscription.tariffPlanDetail.orderedPlan !== ''
        && this.subscription.tariffPlanDetail.orderedPlanActivationDate !== '';
    }

    private getTariffName(tariff: string): string {
        return this.i18next.t(tariffNameTranslationKey(tariff)) as string;
    }
}
